import { ActivatedRouteSnapshot } from '@angular/router';

/** Lê `companyKey` a partir da árvore de rotas (ex.: guards). */
export function readCompanyKeyFromPathFromRoot(route: {
  pathFromRoot: ReadonlyArray<{ paramMap: { get(name: string): string | null } }>;
}): string | null {
  for (const node of route.pathFromRoot) {
    const value = node.paramMap.get('companyKey');
    if (value?.trim()) return value.trim();
  }
  return null;
}

/** Lê `companyKey` a partir de um snapshot (páginas filhas sob `c/:companyKey`). */
export function readCompanyKeyFromActivatedSnapshot(snapshot: ActivatedRouteSnapshot): string {
  let current: ActivatedRouteSnapshot | null = snapshot;
  while (current) {
    const key = current.paramMap.get('companyKey');
    if (key?.trim()) return key.trim();
    current = current.parent;
  }
  return '';
}
